import { db } from './firebaseConfig';
import { ref, set, push } from 'firebase/database';

/**
 * Logs a system-level error encountered by a user.
 * 
 * @param {string} errorCode The unique ERxxxx- formatted code
 * @param {string} message Descriptive error message or exception trace
 * @param {string} path The URL path where the error occurred
 * @param {string} userId (Optional) The SUID-DVT-XXXXXX identifier if the user is logged in
 * @param {object} metadata (Optional) Additional context (e.g., browser, stack trace)
 */
export const logSystemError = async (errorCode, message, path, userId = 'GUEST', metadata = {}) => {
  try {
    const errorRef = ref(db, 'systemErrors');
    const newErrorRef = push(errorRef); // Using push for auto-generated keys in sequential log
    
    await set(newErrorRef, {
      errorCode: errorCode,
      message: message,
      path: path,
      userId: userId,
      metadata: {
        userAgent: navigator.userAgent,
        timestamp: Date.now(),
        ...metadata
      }
    });
    
    console.warn(`[SystemError] Logged ${errorCode} to Admin Portal.`);
  } catch (err) {
    // Fail silently in production to avoid error loops, but log to console in dev
    console.error("Critical Failure: Unable to log system error to Firebase", err);
  }
};
